export const networkIntelligenceQueryKeys = {
  risks: ['network-intelligence', 'risks'],
  summary: ['network-intelligence', 'summary'],
  top: (limit = 10) => ['network-intelligence', 'top', limit],
};
